import React, { Component } from "react";
import { assessmentActions, questionsActions, userActions } from "../../../_actions";
import { connect } from "react-redux";
import Header from '../Component/Header';
import { BsShieldLockFill } from "react-icons/bs";

class Welcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      started: false,
      currentUser: "HK"
    };
  }

  handleStart = () => {
    this.props.history.push("/assessment/welcomeprofile/");
  }
  render() {

    let { questions, assessment, onLogout, switchToAdmin, openAIBot } = this.props;
    let { userAssessmentUserProfileData } = assessment;

    return (
      <div className="min-h-screen flex flex-col justify-between bg-gradient-to-b from-white via-[#E3F2FD] to-[#E3F2FD]">

        {/* Rendered Header Component */}
        <Header userInitials={this.state.currentUser} />

        {/* Main Content Area */}
        <main className="flex-grow flex flex-col items-center justify-center px-4 max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4 tracking-tight">Welcome to TalentPlus!</h1>
          <h2 className="text-xl md:text-2xl font-medium text-slate-700 mb-3 max-w-xl mx-auto leading-snug">Before we discover your strengths, let's know a little about you.</h2>

          <p className="text-base text-slate-500 max-w-xl mx-auto mb-10 leading-relaxed">
            Before we get started, we'd love to know a little about you. Just a few quick questions
            <span className="block md:inline"> - takes under 1 minutes.</span>
          </p>

          {/* Feature Info Cards */}
          <div className="grid grid-cols-3 gap-4 w-full max-w-xl mb-8">
            <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] flex flex-col items-center justify-center border border-white">
              <span className="text-xl md:text-2xl font-medium text-blue-600">3</span>
              <span className="text-xs md:text-sm text-slate-600 font-medium mt-1">quick steps</span>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] flex flex-col items-center justify-center border border-white">
              <span className="text-xl md:text-2xl font-medium text-blue-600">1 min</span>
              <span className="text-xs md:text-sm text-slate-600 font-medium mt-1">to complete</span>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] flex flex-col items-center justify-center border border-white">
              <span className="text-xl md:text-2xl font-medium text-blue-600">100%</span>
              <span className="text-xs md:text-sm text-slate-600 font-medium mt-1">personalised</span>
            </div>
          </div>

          {/* Action Button */}
          <button
            onClick={this.handleStart}
            className="w-full max-w-xl bgcolor hover:bg-blue-600 text-white font-medium py-3.5 rounded-xl transition-all duration-200 active:scale-[0.99] shadow-md shadow-blue-200 text-base"
          >
            Let's Start
          </button>

          {/* Data Security Notice */}
          <div className="flex items-center justify-center space-x-2 mt-5 text-slate-600 text-xs md:text-sm">
            <BsShieldLockFill size={22} className="text-blue-600 flex-shrink-0" />
            <span>Your data is securely protected with encryption and other security best practices.</span>
          </div>

        </main>

        {/* Footer Section */}
        <footer className="w-full text-center py-6 text-sm text-slate-600 tracking-wide">
          All Rights Reserved | Copyright © 2026 TalentPlusStrengths.
        </footer>

      </div>
    );
  }
}


function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}

export default connect(mapStateToProps)(Welcome);